// General mixins
import {
    mapGetters,
    mapMutations,
    mapActions
} from 'vuex';
import * as actionTypes from './store/actionTypes';
import handleErrors from './utils/handleErrors';

export const mixin = {
    methods: {
        ...mapMutations(['stopProcessing', 'addLoaded']),
        ...mapActions(['loadData']),
        openModal(id) {
            this.$bvModal.show(id)
        },
        closeModal(id) {
            this.$bvModal.hide(id)
        },
        getErrorMessage(err) {
            if (!err.response) return err.message;

            const {
                data: {
                    errors
                }
            } = err.response;
            const messages = [];
            Object.keys(errors).map(key => {
                const fieldErrors = errors[key];
                fieldErrors.map(errMsg => messages.push(errMsg));
            });

            return messages.join('\n');
        },
        handleErrors,
        startProcessing() {},
        userCan(capability) {

            // Validar que sea un usurio logueado y contiene perfil y permisos
            if (!this.user || !this.user.profile) return false;

            if (['super_admin', 'administrador'].includes(this.user.profile.slug)) return true;

            return this.userCapabilities.includes(capability.trim());
        },
        /**
         * Función para cargar datos evitando duplicidad de consultas al servidor
         * @param {String} type Tipo de información que se quiere cargar
         * @param {Object} payload Objeto con propiedad force para forzar la carga y params para aplicar parametros a las acciones
         */
        async load(type, payload = {}) {

            const params = Object.assign({
                force: false,
                params: null
            }, payload);


            if (typeof type === 'string' && (type in dictionary)) {
                if (this.loaded.includes(type) && !params.force) return;
                !this.loaded.includes(type) && this.addLoaded(type);
                let res;
                if (!!params.params) {
                    res = await this.$store.dispatch(dictionary[type], params.params);
                } else {
                    res = await this.$store.dispatch(dictionary[type]);
                }
                return res;
            }

            const types = typeof type === 'object' && Array.isArray(type) ? type : Object.keys(type);
            const resps = [];
            types.forEach(key => {
                if (key in dictionary) {
                    if (this.loaded.includes(key) && !params.force) return;
                    let resp = this.$store.dispatch(dictionary[key], force);
                    resps.push(resp);
                    !this.loaded.includes(key) && this.addLoaded(key);
                }
            });
            // return Promise.all(resps).then(results => results);
            return Promise.all(resps);
        },
        moduleEnabled(modSlug) {
            if (!this.client) return false;

            return !!this.client.optional_modules && !!this.client.optional_modules.find(item => item.slug === modSlug);
        },
        async get(resource, params) {
            const {
                data
            } = await repo.get(resource, params)
            return data
        }
    },
    computed: {
        ...mapGetters(['user', 'client', 'isAuthenticated', 'accessPoint', 'inProgress', 'loaded', 'userCapabilities'])
    }
};

export const cookies = {
    methods: {
        setCookie(cname, cvalue, exdays = 365) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    }
};

export const pagination = {
    data() {
        return {
            pagination: {
                from: '',
                to: '',
                lastPage: '',
                total: '',
                delta: 3,
                size: 5
            }
        }
    },
    computed: {
        minPage() {
            return Math.max(1, Math.min(this.page - this.pagination.delta, this.pagination.lastPage - this.pagination.size));
        },
        maxPage() {
            return Math.min(this.pagination.lastPage, this.minPage + this.pagination.size);
        }
    }
}

const dictionary = {
    arls: actionTypes.LOAD_ARLS,
    administrativeUsers: actionTypes.LOAD_ADMINISTRATIVE_USERS,
    annotationTypes: actionTypes.LOAD_ANNOTATION_TYPES,
    capabilities: actionTypes.LOAD_CAPABILITIES,
    cities: actionTypes.LOAD_CITIES,
    clients: actionTypes.LOAD_CLIENTS,
    clientTypes: actionTypes.LOAD_CLIENT_TYPES,
    executives: actionTypes.LOAD_EXECUTIVES,
    identificationTypes: actionTypes.LOAD_IDENTIFICATION_TYPES,
    itemTypes: actionTypes.LOAD_ITEM_TYPES,
    mailTypes: actionTypes.LOAD_MAIL_TYPES,
    months: actionTypes.LOAD_MONTHS,
    passengerTypes: actionTypes.LOAD_PASSENGER_TYPES,
    people: actionTypes.LOAD_PEOPLE,
    petitionStatuses: actionTypes.LOAD_PETITION_STATUSES,
    petitionTypes: actionTypes.LOAD_PETITION_TYPES,
    positions: actionTypes.LOAD_POSITIONS,
    profiles: actionTypes.LOAD_PROFILES,
    structureTypes: actionTypes.LOAD_STRUCTURE_TYPES,
    tools: actionTypes.LOAD_TOOLS,
    validYears: actionTypes.LOAD_VALID_YEARS,
    vehicleTypes: actionTypes.LOAD_VEHICLE_TYPES,
    vehicleEntryMasterData: actionTypes.LOAD_VEHICLE_ENTRY_MASTER_DATA,
    visitorTypes: actionTypes.LOAD_VISITOR_TYPES,
    years: actionTypes.LOAD_VALID_YEARS,
    supervisors: actionTypes.LOAD_SUPERVISORS,
}

export const randomColors = {
    methods: {
        getColors(n) {
            const colors = [];
            for (let i = 0; i < this.chartData.length; i++) {
                colors.push('#' + Math.floor(Math.random() * 16777215).toString(16));
            }
            return colors;
        }
    }
}

export const reportDataProcess = {
    methods: {
        processPersonEntryData(data) {
            const personEntriesData = [];
            personEntriesData.push(['Tipo', 'Cantidad']);
            data.map(item => {
                personEntriesData.push([item.name, item.total]);
            });

            return personEntriesData;
        },
        processVehicleEntryData(data) {
            const vehicleEntriesData = [];
            vehicleEntriesData.push(['Tipo', 'Cantidad']);
            data.map(item => {
                vehicleEntriesData.push([item.name, item.total]);
            });

            return vehicleEntriesData;
        },
        processMailData(data) {
            const mailsData = [];
            mailsData.push(['Tipo', 'Cantidad']);
            data.map(item => {
                mailsData.push([item.name, item.total]);
            });

            return mailsData;
        },
        processDeliveredMailsData(data) {
            const deliveredMailsData = [];
            deliveredMailsData.push(['Estado', 'Cantidad']);
            data.map(item => {
                deliveredMailsData.push([item.name, item.total]);
            });

            return deliveredMailsData;
        },
        processTop10StructuresByVisitors(data) {
            const top10StructuresByVisitors = [];
            top10StructuresByVisitors.push(['Estructura', 'Visitas']);
            data.map(item => {
                top10StructuresByVisitors.push([item.name, item.total]);
            });

            return top10StructuresByVisitors;
        },
        processHistoricalEntries(data) {
            const historicalEntries = [];
            historicalEntries.push(['Mes', 'Visitas']);
            data.map(item => {
                historicalEntries.push([item.name, item.total])
            });

            return historicalEntries;
        },
        processNotebookData(data) {
            const notebookData = [];
            notebookData.push(['Tipo de Anotación', 'Cantidad']);
            data.map(item => {
                notebookData.push([item.name, item.total])
            });

            return notebookData;
        },
        processPqrIndicatorData(data) {
            const pqrIndicatorData = [];
            pqrIndicatorData.push(['Estado', 'Cantidad']);
            data.map(item => {
                pqrIndicatorData.push([item.name, item.total])
            });

            return pqrIndicatorData;
        },
    }
}
